import api from "../../../services/apiClient"
import type { DocumentCategoryFormValues } from "../models/documentCategory"

const BASE = "document-category"

export const documentCategoryApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },
  getAll: async () => {
    const { data } = await api.get(`${BASE}/all`)
    return data?.data ?? data
  },
  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },
  create: async (values: DocumentCategoryFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  update: async (id: number, values: Partial<DocumentCategoryFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },
  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },
  getHierarchy: async (excludeId?: number) => {
    const params = excludeId ? { exclude_id: excludeId } : undefined
    const { data } = await api.get(`${BASE}/hierarchy`, { params })
    return data?.data ?? data
  },
  reorder: async (items: { id: number; root: number; order: number }[]) => {
    const { data } = await api.post(`${BASE}/reorder`, { items })
    return data
  },
}
